export default __webpack_public_path__ + "static/media/Bone-picker's Helm.889a50c4.jpg";